import { QueryKey } from '@tanstack/react-query';
import { parseSlug } from 'utils/cms/parseSlug';
import { KEYS } from 'utils/createKeyFactory';

const cmsKey = KEYS.CMS;

export const cmsFactory = {
  all: (): QueryKey => [cmsKey],
  page: (slug?: string | string[]): QueryKey => [cmsKey, parseSlug(slug)],
  modal: (params?: QueryKey): QueryKey => Array.prototype.flat.call([cmsKey, 'CMSmodal', params]),
};
